import { TableCell } from "@mui/material";
import { DotLegalDialog, DotLegalTable, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import TableRow from "@common/components/tableRow/TableRow";
import { RiskSnapshotDate } from "./RiskGovernanceOverview.types";

interface RiskSnapshotDialogProps {
    isLoading: boolean;
    dates: Array<RiskSnapshotDate>;
    onSelectDate: (date: string) => void;
    onClose: () => void;
}

// The "go back in time" picker (work item #6698): the distinct dates an assessment was revised, with per-source
// counts. Picking a row recomputes the whole overview as it stood on that date.
function RiskSnapshotDialog(props: RiskSnapshotDialogProps) {
    const { translateString, translateDate, translateNumber } = useTranslation();

    const headers: Array<ITableHeader<RiskSnapshotDate>> = [
        { property: "date", text: translateString("date") },
        { property: "manualCount", text: translateString("riskGovernanceSnapshotManual") },
        { property: "reconfirmedCount", text: translateString("riskGovernanceSnapshotReconfirmed") },
        { property: "promotedCount", text: translateString("riskGovernanceSnapshotPromoted") },
    ];

    return (
        <DotLegalDialog
            open
            size="md"
            header={translateString("riskGovernanceSnapshotDialogTitle")}
            buttonOkText={translateString("close")}
            hideOkButton
            onDialogClose={props.onClose}
            onOkClick={props.onClose}
        >
            <DotLegalTable
                headers={headers}
                defaultOrderBy={"date"}
                defaultOrder={"desc"}
                data={props.dates}
                isLoading={props.isLoading}
                hidePagination
                disableFilterAndSortAndSlicing
                emptyText={translateString("noData")}
                clickableRows
                renderRow={(row) => (
                    <TableRow key={row.date} onClick={() => props.onSelectDate(row.date)} sx={{ cursor: "pointer" }}>
                        <TableCell>{translateDate(new Date(row.date))}</TableCell>
                        <TableCell>{translateNumber(row.manualCount)}</TableCell>
                        <TableCell>{translateNumber(row.reconfirmedCount)}</TableCell>
                        <TableCell>{translateNumber(row.promotedCount)}</TableCell>
                    </TableRow>
                )}
            />
        </DotLegalDialog>
    );
}

export default RiskSnapshotDialog;
